import React from 'react';
import styles from './noData.module.scss';

const NoData = () => {
  return <div className={styles.text}>There is no PDF file.</div>;
};

export default NoData;
